<template>
  <div>
    <m-modal-create-account />
    <b-tabs content-class="mt-5" active-nav-item-class="navitemactive"  fill>
      <b-tab title="Reach My Audience" title-link-class="navitem" active>
        <b-row class="m-hero-title">
        <b-col>
          <h1>
            Reach My Audience
          </h1>
          <p class="mt-2" v-if="topBtns.length===0&&normalBtns.length===0">In this section you may choose an audience using a variety of filters for a direct mail, digital, and/or telemarketing campaign. Contact us at <b-link href="tel://800-399-8611">800-399-8611</b-link> or at <b-link href="mailto:support@sl360.com">support@sl360.com</b-link> to activate this section of your account.</p>
        </b-col>
      </b-row>
        <b-row align-h="end" style="margin-top: -60px;margin-bottom: 24px;">
          <b-col sm="8" md="8">
          </b-col>
          <b-col>
            <b-form-select v-model="accountId">
              <option v-for="item in accountList" :value="item.AccountId">
                {{item.AccountName}}
              </option>
            </b-form-select>
          </b-col>
            <b-col md="1"><span v-b-modal.modelAddAccount
                         style="padding-left:10px; cursor: pointer; color: #f66; font-weight: bold"><icon name="plus-circle"/></span>
          </b-col>
        </b-row>
        <b-row align-h="center" v-if="topBtns.length!==0||normalBtns.length!==0">
          <b-col sm="2" md="2" lg="2" v-for="item in topBtns" :key="item.ListType">
            <!-- Prospect Lists -->
            <div class="datasource-item">
              <div>
                <a href="javascript:void(0);" @click="next(item.ListType)"><img :src="'./static/img/datasource/'+ getImageNmae(item.ListType) +'_v3.png'"></a>
              </div>
              <p style="text-align: center"><a class="datasource-a" v-text="item.Desc.toUpperCase()" href="javascript:void(0);" @click="next(item.ListType)"></a></p>
            </div>
          </b-col>
          <b-col sm="2" md="2" lg="2" v-for="item in normalBtns" :key="item.ListType">
            <!-- Prospect Lists -->
            <div class="datasource-item">
              <div>
                <a href="javascript:void(0);" @click="next(item.ListType)"><img :src="'./static/img/datasource/'+ getImageNmae(item.ListType) +'_v3.png'"></a>
              </div>
              <p style="text-align: center"><a v-text="item.Desc.toUpperCase()" class="datasource-a" href="javascript:void(0);" @click="next(item.ListType)"></a></p>
            </div>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab title="Enhance Your Data" title-link-class="navitem">
        <b-row class="m-hero-title">
          <b-col>
            <h1>
              Enhance Your Data
            </h1>
            <p class="mt-2" v-if="serviceList('enhance')">Append our data to your current book of business so you can segment and target customers better.</p>
            <p class="mt-2" v-if="!serviceList('enhance')">In this section you are able to append any combination of demographic, psychographic, and contact information (e.g. phone numbers, email addresses, postal addresses) to your customer database. Contact us at <b-link href="tel://800-399-8611">800-399-8611</b-link> or at <b-link href="mailto:support@sl360.com">support@sl360.com</b-link> to activate this section of your account.</p>
          </b-col>
        </b-row>
        <b-row align-h="center" v-if="serviceList('enhance')">
          <b-col  sm="3" md="3" lg="3" v-for="menu in menus" v-if="menu.type === 'enhance' && menu.show" :key="item.link">
            <!-- Prospect Lists -->
            <div class="datasource-item">
              <div>
                <a :href="$store.getters['config/link'](menu.link)"><img :src="'./static/img/datasource/'+ menu.link +'.png'"></a>
              </div>
              <p style="text-align: center"><a class="datasource-a" v-text="menu.title.toUpperCase()" href="$store.getters['config/link'](menu.link)"></a></p>
            </div>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab title="Clean & Verify Your Data" title-link-class="navitem">
        <b-row class="m-hero-title">
          <b-col>
            <h1>
              Clean & Verify Your Data
            </h1>
            <p class="mt-2" v-if="serviceList('clean')">De-duplicate records, correct undeliverable addresses and screen for privacy… all to save time and money.</p>
            <p class="mt-2"  v-if="!serviceList('clean')">
              In this section you are able to refresh the contact information in your database and flag records with privacy concerns (e.g. Do Not Contact, Underage). Contact us at <b-link href="tel://800-399-8611">800-399-8611</b-link> or at <b-link href="mailto:support@sl360.com">support@sl360.com</b-link> to activate this section of your account.
            </p>
          </b-col>
        </b-row>
        <b-row align-h="center" v-if="serviceList('clean')">
          <b-col  sm="3" md="3" lg="3" v-for="menu in menus" v-if="menu.type === 'clean' && menu.show" :key="item.link">
            <!-- Prospect Lists -->
            <div class="datasource-item">
              <div>
                <a :href="$store.getters['config/link'](menu.link)"><img :src="'./static/img/datasource/'+ menu.link +'.png'"></a>
              </div>
              <p style="text-align: center"><a class="datasource-a" v-text="menu.title.toUpperCase()" href="$store.getters['config/link'](menu.link)"></a></p>
            </div>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab title="Analyze My Customers" title-link-class="navitem">
        <b-row class="m-hero-title">
          <b-col>
            <h1>
              Analyze My Customers
            </h1>
            <p class="mt-2">Gain insight into the demographic and psychographic characteristics of your customers, and identify prospects likely to become new customers.</p>
            <p class="mt-2" v-if="false">In this section you can order reports which provide insight into the demographic and psychographic composition of your customers including which characteristics they’re more likely to have relative to all adults in your area. Contact us at <b-link href="tel://800-399-8611">800-399-8611</b-link> or at <b-link href="mailto:support@sl360.com">support@sl360.com</b-link> to activate this section of your account.</p>
          </b-col>
        </b-row>
        <b-row align-h="center">
          <b-col  sm="5" md="5" lg="5">
            <!-- Prospect Lists -->
            <div class="datasource-item">
              <div>
                <a :href="$store.getters['config/link']('portaitreports')"><img :src="'./static/img/datasource/portaitreports_v3.png'"></a>
              </div>
              <p style="text-align: center"><a class="datasource-a" v-text="'Customer Portrait Reports'.toUpperCase()" href="$store.getters['config/link']('portaitreports')"></a></p>
            </div>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
  import _ from 'lodash'
  import MModalCreateAccount from '@/components/landings/MModalCreateAccount'
  export default {
    components: {MModalCreateAccount},
    data () {
      return {
        item: {},
        status: this.$store.state.user,
        datasourceImage: [
          {10: '../../../static/img/datasource/consumer.png'},
          {170: '../../../static/img/datasource/business.png'}
        ]
      }
    },
    computed: {
      topBtns () {
        let result = []
        for (let item of this.status.userDataSources) {
          if (item.ListType === 10 || item.ListType === 170) {
            result.push(item)
          }
        }
        return result
      },
      normalBtns () {
        var result = []
        for (let item of this.status.userDataSources) {
          if (item.ListType !== 10 && item.ListType !== 170) {
            result.push(item)
          }
        }
        return result
      },
      userServiceDataSources () {
        return this.$store.state.user.userServiceDataSources
      },
      accountList () {
        return this.$store.getters['user/accountList']
      },
      accountId: {
        get () {
          return this.$store.getters['user/accountId']
        },
        set (val) {
          this.$store.commit('user/saveKey', ['accountId', val])
        }
      },
      menus () {
        var result = [
          {
            title: 'Append Demographics or Psychographics',
            benefit: 'Gives your customer database more segmentation capabilities and helps you better communicate with customers around their interests and life stage.',
            link: 'enhanceList',
            icon: 'share-alt',
            type: 'enhance',
            show: this.userServiceDataSources.showEnhanceList
          }, {
            title: 'Clean your Database',
            benefit: 'Save money avoiding duplicate and undeliverable mail, and marketing to only those qualified for your product or service.',
            link: 'cleanList',
            icon: 'eraser',
            type: 'clean',
            show: this.userServiceDataSources.showCleanList
          }, {
            title: 'Append Email Addresses',
            benefit: 'Adding email addresses to your database helps you communicate with customers through a new and low-cost channel.',
            link: 'emailAppend',
            icon: 'envelope-open-o',
            type: 'enhance',
            show: this.userServiceDataSources.showEmailAppend
          }, {
            title: 'Verify Email Addresses',
            benefit: 'Reduces undeliverable email which helps keep your sender reputation strong so ESPs continue delivering your email.',
            link: 'emailVerification',
            icon: 'envelope-o',
            type: 'clean',
            show: this.userServiceDataSources.showEmailVerification
          }, {
            title: 'Append Phone Numbers',
            benefit: 'Provides an additional and low cost channel to communicate with customers.',
            link: 'phoneAppend',
            icon: 'phone',
            type: 'enhance',
            show: this.userServiceDataSources.showPhoneAppend
          }, {
            title: 'Reverse Phone Append',
            benefit: 'Helps reveal who contacted you and enables you to reach them via direct mail.',
            link: 'phoneReverse',
            icon: 'phone',
            type: 'enhance',
            show: this.userServiceDataSources.showPhoneReverse
          }, {
            title: 'Reverse Email Append',
            benefit: 'Helps reveal who contacted you and enables you to reach them via direct mail.',
            link: 'reverseEmailAppend',
            icon: 'envelope-open-o',
            type: 'enhance',
            show: this.userServiceDataSources.showEmailReverse || this.userServiceDataSources.showEmailAppend
          }, {
            title: 'Phone Confirmation & Append',
            benefit: 'Saves you time calling bad numbers and improves your connection rate with customers.',
            link: 'phoneVerification',
            icon: 'volume-control-phone',
            type: 'clean',
            show: this.userServiceDataSources.showPhoneVerification
          }
        ]
        return result
      },
      showHistoryMenu () {
        if (this.$store.state.user.ShowDigitalHistory && this.$store.state.user.ShowOrderHistory) {
          return true
        } else {
          return false
        }
      },
      showOrderHistoryMenu () {
        if (!this.$store.state.user.ShowDigitalHistory && this.$store.state.user.ShowOrderHistory) {
          return true
        } else {
          return false
        }
      },
      showDigitalHistoryMenu () {
        if (this.$store.state.user.ShowDigitalHistory && !this.$store.state.user.ShowOrderHistory) {
          return true
        } else {
          return false
        }
      }
    },
    methods: {
      next (listType) {
        this.$router.push({
          name: 'order',
          params: {
            listType: listType
          }
        })
      },
      serviceList (type) {
        return _.filter(this.menus, item => {
          return item.type === type && item.show
        }).length > 0
      },
      getImageNmae (listType) {
        if (listType === 80 || listType === 220 || listType === 230 || listType === 240 || listType === 100 || listType === 250 || listType === 270 || listType === 150) {
          return 10
        } else if (listType === 140) {
          return 60
        } else if (listType === 130) {
          return 50
        } else if (listType === 90 || listType === 120 || listType === 160 || listType === 170 || listType === 260) {
          return 20
        } else {
          return listType
        }
      },
      showCreateAccount () {
        this.$root.$emit('bv::show::modal', 'modelAddAccount')
      }
    }
  }
</script>

<style scoped>
  h1 {
    font-size: 1.6rem;
    color: #f66;
  }
.btn-reach {
  margin-bottom: 10px;
}
.m-hero-title {
  margin-top: -16px;
  text-align: center;
  margin-bottom: 16px;
}
.datasource-a {
  font-weight: bold;
}
.datasource-item {
  text-align: center;
  margin-top: 16px;
}
.btn-outline-primary { border-color: #f66; color: #f66; }
.btn-outline-primary:hover { background-color: #f66!important; color: #FFFFFF!important;border-color: #f66!important; }

  a{
    color: #f66!important;
  }

</style>
<style>
  .navitemactive {
    background-color: #f66!important;
    color: #fff!important;
  }
 .navitem {    font-size: 0.85rem!important;
   line-height: 1rem!important;
   font-weight: 600!important;
   background-color: #fff;
   padding: 1rem 0.4rem!important;
   color: #999;
   text-transform: uppercase!important;
   border: 1px solid #ccc!important;
   width: 100%!important;
   display: block!important;
   transition: all 250ms ease-in-out!important;
   }

  .navitem:hover {
    background-color: rgba(255,102,102,0.8)!important;
    color: #fff!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/landings/MHero.vue